import { curry, flow } from 'lodash';

import { THEME_COLORS_SECONDARY } from '../../types/theme';

function stringToHash(str: string): number {
  if (str.length === 0) return 0;

  const hash = str.split('').reduce((acc, el) => {
    const chr = el.charCodeAt(0);
    return ((acc << 5) - acc + chr) | 0; // hash and convert to 32bit number
  }, 0);

  return Math.abs(hash);
}

function pickWithHash<T>(arr: T[], hash: number): T {
  return arr[hash % arr.length];
}

const pickColorWithHash: (v: number) => string = curry(pickWithHash)(
  Object.keys(THEME_COLORS_SECONDARY)
);

export const stringToColor = flow(stringToHash, pickColorWithHash);
